import Axios from 'axios'

import getDomainURL from 'utils/api'
import { getToken } from 'utils/findCookieToken'
import FileSaver from 'file-saver'

export const Get = ( url, response, error, load, host ) => {
  load( true )
  Axios.defaults.headers = {
    common: {
      Authorization: `Bearer ${ getToken( 'ACISO_SESSION_TOKEN' ) }`
    }
  }
  Axios.defaults.responseType = "json";
  return Axios.get( `${ getDomainURL() }${ url }`, {
    headers: {
      'X-Host': host ? host : ''
    }
  }).then( async res => {
    await response( res.data )
    load( false )
  }).catch( async( err ) => {
    if( err?.response?.status ) {
      if( err.response.data.message ){
        await error( err.response.data.message )
      } else if( err.response.data.Error ) {
        await error( err.response.data.Error )
      } else if( err.response.data.Errors ) {
        await error( err.response.data.Errors )
      } else {
        await error( err.message || 'An unexpected error occurred' )
      }
    } else if( err && err.message ) {
      await error( err.message )
    } else {
      await error( 'You are disconnnected from the internet, please reconnect to use Admin Portal. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}

export const Post = ( url, data, response, error, load, host ) => {
  load( true )
  let token = getToken( 'ACISO_SESSION_TOKEN' )
  Axios.defaults.headers = {
    common: {
      'Authorization': `Bearer ${ token }`
    }
  }
  return Axios.post( `${ getDomainURL() }${ url }`, data, {
    headers: {
      'X-Host': host ? host : ''
    }
  }).then( async res => {
    await response( res.data )
    load( false )
  }).catch( async( err ) => {
    if( err && err.response && err.response.status ) {
      let tmp = err.response.status
      if( tmp === 422 || tmp === 401 ) {
        if( err.response.data.Errors ){
          await error( err.response.data.Errors )
        }
        if( err.response.data.Error ){
          await error( err.response.data.Error )
        }
      } else {
        if( err.response.data.message ){
          await error( err.response.data.message )
        } else if( err.response.data.Error ){
          await error( err.response.data.Error )
        } else if( err.response.data.Errors ){
          await error( err.response.data.Errors )
        } else {
          await error( err.message || 'An unexpected error occurred' )
        }
      }
    } else if( err ) {
      await error( err.message )
    } else {
      await error( 'You are disconnnected from the internet, please reconnect to use Admin Portal. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}

export const Put = ( url, data, response, error, load, host ) => {
  load( true )
  let token = getToken( 'ACISO_SESSION_TOKEN' )
  Axios.defaults.headers = {
    common: {
      'Authorization': `Bearer ${ token }`
    }
  }
  return Axios.put( `${ getDomainURL() }${ url }`, data, {
    headers: {
      'X-Host': host ? host : ''
    }
  }).then( res => {
    response( res.data )
    load( false )
  }).catch( async( err ) => {
    if( err && err.response && err.response.status ) {
      let tmp = err.response.status
      if( tmp === 422 || tmp === 401 ) {
        if( err.response.data.Error ) {
          await error( err.response.data.Error )
        }
        if( err.response.data.Errors ){
          await error( err.response.data.Errors )
        }
      } else {
        if( err.response.data.message ){
          await error( err.response.data.message )
        } else if( err.response.data.Error ){
          await error( err.response.data.Error )
        } else if( err.response.data.Errors ){
          await error( err.response.data.Errors )
        } else {
          await error( err.message || 'An unexpected error occurred' )
        }
      }
    } else if( err ) {
      await error( err.message )
    } else {
      await error( 'You are disconnnected from the internet, please reconnect to use Admin Portal. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}

export const Delete = ( url, response, error, load, data, host ) => {
  load( true )
  let token = getToken( 'ACISO_SESSION_TOKEN' )
  Axios.defaults.headers = {
    common: {
      'Authorization': `Bearer ${ token }`
    }
  }
  return Axios.delete( `${ getDomainURL() }${ url }`, { data: data }, {
    headers: {
      'X-Host': host ? host : ''
    }
  }).then( res => {
    response( res.data )
    load( false )
  }).catch( err => {
    if( err && err.response && err.response.status ) {
      let tmp = err.response.status
      if( tmp === 422 || tmp === 401 ) {
        error( err.response.data.Error )
      } else {
        if( err.response.data.message ){
          error( err.response.data.message )
        } else if( err.response.data.Error ){
          error( err.response.data.Error )
        } else if( err.response.data.Errors ){
          error( err.response.data.Errors )
        } else {
          error( err.message || 'An unexpected error occurred' )
        }
      }
    } else if( err ) {
      error( err.message )
    } else {
      error( 'You are disconnnected from the internet, please reconnect to use Admin Portal. If problem persists, please contact the system admin.' )
    }
    load( false )
  })
}

export const DownloadFile = ( url, savedFilename, error, load, host ) => {
  load( true )
  Axios.defaults.headers = {
    common: {
      Authorization: `Bearer ${ getToken( 'ACISO_SESSION_TOKEN' ) }`
    }
  }
  return Axios.get( `${ getDomainURL() }${ url }`, {
    responseType: 'blob',
    headers: {
      'X-Host': host ? host : ''
    }
  }).then( res => {
    return res.data
  }).then( blobby => {
    FileSaver.saveAs( blobby, savedFilename )
    load( false )
  }).catch( err => {
    error( err.message )
    load( false )
  })
}


// this is using PUT
export const GetFile = async (url, savedFilename, data, response, error, load, host ) => {
  load(true);
  let token = getToken( 'ACISO_SESSION_TOKEN' )
  Axios.defaults.headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
  };
  Axios.defaults.responseType = "blob";
  return Axios.put( `${ getDomainURL() }${ url }`, data, {
    headers: {
      'X-Host': host ? host : ''
    }
  }).then(async (res) => {
      load(false);
      if(res.status === 200){
        const resultBlob = new Blob([res.data]);
        FileSaver.saveAs(resultBlob, savedFilename);
        response(resultBlob);
      }
    })
    .catch((err) => {
      if (err && err.response) {
        if (err.response.status === 401) {
          error( err.response.data.Error )
        }
      } else {
        error('You are disconnnected from the internet, please reconnect to use Admin Portal. If problem persists, please contact the system admin.');
      }
      load(false);
    });
};

export const GetFileGet = async (url, savedFilename, response, error, load, host ) => {
  load(true);
  let token = getToken( 'ACISO_SESSION_TOKEN' )
  Axios.defaults.headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${token}`,
  };
  Axios.defaults.responseType = "blob";
  return Axios.get( `${ getDomainURL() }${ url }`, {
    headers: {
      'X-Host': host ? host : ''
    }
  }).then(async (res) => {
      load(false);
      if(res.status === 200){
        const resultBlob = new Blob([res.data]);
        FileSaver.saveAs(resultBlob, savedFilename);
        response(resultBlob);
      }
    })
    .catch(async (err) => {
      if( err && err.response && err.response.status ) {
        let tmp = err.response.status
        if( tmp === 422 || tmp === 401 ) {
          const errText = await err.response.data.text();
          const errJson = JSON.parse(errText);

          if( errJson.Error ) {
            await error( errJson.Error )
          }
          if( errJson.Errors ){
            await error( errJson.Errors )
          }
        }
      } else if( err ) {
        await error( err.message )
      } else {
        await error( 'You are disconnnected from the internet, please reconnect to use Admin Portal. If problem persists, please contact the system admin.' )
      }
      load(false);
    });
};